import { render, staticRenderFns } from "./StatistiquesList.vue?vue&type=template&id=18daba2b&scoped=true&"
import script from "./StatistiquesList.vue?vue&type=script&lang=js&"
export * from "./StatistiquesList.vue?vue&type=script&lang=js&"
import style0 from "./StatistiquesList.vue?vue&type=style&index=0&id=18daba2b&lang=scss&scoped=true&"
import style1 from "./StatistiquesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18daba2b",
  null
  
)

export default component.exports